<div class="h-100">
    <div class="row h-100">
        <div class="col-12 lato-bold font-size-20 color-whaleTail my-4">
            <span cvLocalizedText langSection="MarketPlace" langKey="My_Order_History">My Order History</span>
        </div>
        <div class="col-12 h-100">
            <ag-grid-angular #agentOrderHistoryGrid id="ordersGrid" *ngIf="gridOptions != null && pscs.pointStoreVisibleContent.showOrdersPage && !pspos.isUpdating"
                    class="ag-theme-balham flex-fill"
                    [gridOptions]="gridOptions"
            ></ag-grid-angular>
        </div>
    </div>
</div>